import type { loginResponse } from "../models/auth-model";

import { redirect } from "react-router";

import { post } from "~/core/lib/api";

// 로그인 상태 변경을 알리는 커스텀 이벤트명
export const AUTH_STATE_CHANGE_EVENT = "authStateChange";

// 로그인 상태 변경 이벤트 발생 함수
export const dispatchAuthStateChange = (
  isLoggedIn: boolean,
  user?: any,
): void => {
  if (typeof window !== "undefined") {
    const event = new CustomEvent(AUTH_STATE_CHANGE_EVENT, {
      detail: { isLoggedIn, user },
    });
    window.dispatchEvent(event);
  }
};

// 유저 정보 가져오기 함수
export const getUserInfo = (): any | null => {
  if (typeof window === "undefined") {
    return null;
  }
  const tnmtName = localStorage.getItem("tnmtName");
  if (!tnmtName) return null;
  try {
    return tnmtName;
  } catch (e) {
    console.error("유저 정보 파싱 실패:", e);
    return null;
  }
};

// 로그인 상태 확인 함수
export const isLoggedIn = (): boolean => {
  if (typeof window === "undefined") {
    return false; // 서버 사이드에서는 로그인하지 않은 상태로 간주
  }

  const token = localStorage.getItem("accessToken");
  return !!token; // 토큰이 있으면 true, 없으면 false 반환
};

// 로그아웃 함수
export const logout = async (): Promise<void> => {
  try {
    // 서버 로그아웃 요청 (필요한 경우)
    // 서버에 로그아웃 API가 있다면 호출
    // await post<successResponse>('/login/logout', {});

    // 로컬 스토리지에서 토큰과 유저 정보 삭제
    if (typeof window !== "undefined") {
      localStorage.removeItem("accessToken");
      localStorage.removeItem("tnmtName");
      localStorage.removeItem("tnmtId");
      localStorage.removeItem("sportsType");
      localStorage.removeItem("tnmtCategory");
      // 로그아웃 상태 변경 이벤트 발생
      dispatchAuthStateChange(false);
      // 홈 페이지로 리다이렉트
      window.location.href = "/";
    }
  } catch (error) {
    console.error("로그아웃 중 오류 발생:", error);

    // 오류가 발생해도 로컬 스토리지에서는 삭제
    if (typeof window !== "undefined") {
      localStorage.removeItem("tnmtName");
      localStorage.removeItem("sportsType");
      localStorage.removeItem("tnmtId");
      localStorage.removeItem("tnmtCategory");
      localStorage.removeItem("broadcastYn");
      localStorage.removeItem("accessToken");
      // user 정보도 함께 삭제

      // 로그아웃 상태 변경 이벤트 발생
      dispatchAuthStateChange(false);

      window.location.href = "/";
    }
  }
};

export const authApi = {
  loginTab: (tnmtId: string, password: string) => {
    return post<loginResponse>("/loginTab", { tnmtId, password});
  },
};
